export const NUMBERS = {
  ZERO: 0,
  TEN: 10,
  ONEHUNDRED: 100
};
